import { useEffect } from "react";
import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

const Preloader = ({ onDone }) => {
  useEffect(() => {
    const t = setTimeout(onDone, 2100);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <motion.div
      className="fixed inset-0 z-[100] bg-ink flex flex-col items-center justify-center"
      exit={{ y: "-100%" }}
      transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
      data-testid="page-intro-curtain"
    >
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[420px] h-[420px] rounded-full bg-gold/[0.05] blur-[110px] pointer-events-none" />

      <div className="relative w-28 h-28 sm:w-32 sm:h-32" data-testid="intro-logo-stage">
        <svg viewBox="0 0 100 100" className="absolute inset-0 w-full h-full -rotate-90">
          <motion.circle
            cx="50" cy="50" r="48" fill="none" stroke="#D4AF37" strokeWidth="1"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 1.1, ease: "easeInOut" }}
          />
        </svg>
        <motion.img
          src="/atlas-logo-256.png"
          alt="Atlas Trading Community"
          className="absolute inset-[7px] w-[calc(100%-14px)] h-[calc(100%-14px)] rounded-full object-cover"
          initial={{ opacity: 0, scale: 0.82, filter: "blur(6px)" }}
          animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
          transition={{ delay: 0.55, duration: 0.8, ease: EASE }}
        />
      </div>

      <motion.p
        className="mt-7 font-display font-extrabold tracking-[0.45em] text-2xl text-slate-50 pl-2"
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.95, duration: 0.7, ease: EASE }}
        data-testid="intro-wordmark"
      >
        ATLAS
      </motion.p>
      <motion.p
        className="mt-3 font-mono text-[10px] tracking-[0.35em] text-gold/80 uppercase"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.3, duration: 0.6 }}
        data-testid="intro-tagline"
      >
        Analysis · Technology · Independence
      </motion.p>
    </motion.div>
  );
};

export default Preloader;
